import React from 'react';
import { FormikValues } from 'formik';
import {
  useDeleteLocationBlackoutMutation,
  useDeletePhysicianBlackoutMutation,
} from '@api/blackout/blackoutAPI';
import { errorAlert, successAlert } from '@helpers/alerts/alerts';
import { Button } from '@components/Button';
import { useModal } from '@components/Modal/context/useModalContext';
import { BlackoutType } from '@pages/Schedule/components/Blackout/type';
import { useScheduleContext } from '@pages/Schedule/context/useScheduleContext';
import { BlackoutComponents } from '@pages/Schedule/components/Blackout/BlackoutForm/BlackoutComponents';

import './styles.scss';

interface IEditBlackoutProps {
  blackoutType: BlackoutType;
  blackoutId?: string;
  onSubmitFormForce: (formValues: FormikValues, closeModal: () => void) => void;
}

export const EditBlackout: React.FC<IEditBlackoutProps> = ({
  blackoutType,
  blackoutId,
  onSubmitFormForce,
}) => {
  const [deletePhysicianBlackout] = useDeletePhysicianBlackoutMutation();

  const [deleteLocationBlackout] = useDeleteLocationBlackoutMutation();

  const { closeModal } = useModal();

  const { refetch } = useScheduleContext();

  const deleteBlackoutFn =
    blackoutType === BlackoutType.physician ? deletePhysicianBlackout : deleteLocationBlackout;

  const deleteBlackout = async () => {
    try {
      await deleteBlackoutFn(blackoutId).unwrap();
      successAlert(
        blackoutType === BlackoutType.physician
          ? 'Physician blackout successfully deleted'
          : 'Location blackout successfully deleted',
      );
      refetch();
      closeModal();
    } catch (error) {
      errorAlert('Failed to delete blackout');
    }
  };

  return (
    <div className="form-body">
      <BlackoutComponents
        blackoutType={blackoutType}
        isEditForm
        onSubmitFormForce={onSubmitFormForce}
      />

      <div className="button-delete">
        <Button
          label="Delete blackout"
          variant="danger"
          size="large"
          handleClick={deleteBlackout}
        />
      </div>
    </div>
  );
};
